import APIRequestService from './APIRequestService';

const request = new APIRequestService();

export const getFiduciaryPendingLinesups = async ({ selectedFiduciary }) => {
  const url = `/fiduciaries/${selectedFiduciary}/pending-lineups`;
  return request.get(url);
};
